export default "__VITE_ASSET__DzAjFmR1__"